export { default } from './RaffleTicket'
